export default "__VITE_ASSET__CsSRTWmD__"